class BuyingJourney extends HTMLElement {
  constructor() {
    super();
    this.currentTab = 0; // Current tab is set to be the first tab (0)
    let nextTab = 1;
    let prevTab = -1;
    this.allowloading = true;
    this.prevStepButton = document.getElementById('prevStepBtn');
    this.nextStepButton = document.getElementById('nextStepBtn');
    this.buyingSteps = this.querySelectorAll('.step-container');
    const parent = this;
    this.prevStepButton.addEventListener('click', function () {
      parent.switchStep(prevTab);
      parent.allowloading = false;
    });
    this.nextStepButton.addEventListener('click', function () {
      parent.switchStep(nextTab);
      parent.allowloading = true;
    });
  }

  connectedCallback() {
    this.render();
  }

  render() {
    this.initializeFooterSteps(); // Initialize the footer steps
    this.setActiveStepOnUrlParam();
  }

  initializeFooterSteps() {
    const allSteps = this.buyingSteps;
    let stepsWrapper = this.querySelector('.footer-steps');
    let prevStepName = '';
    allSteps.forEach((step, index) => {
      const currentStepName = step.dataset.stepName;
      if (currentStepName != prevStepName) {
        const newStep = `
         <div class="step" data-step-For="${currentStepName}">
            <div class="step-info">
              <span class="step-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <rect width="16" height="16" rx="8" fill="#D3D9EA"/>
                  <path d="M6.07018 9.37922L4.35691 7.72469L3 9.03243L6.07018 12L13 5.31039L11.6431 4L6.07018 9.37922Z" fill="#FAFCFF"/>
                </svg>
              </span>
              <span class="step-text">
                ${currentStepName}
              </span>
              <span class="step-dot">
                •
              </span>
            </div>
          </div>  
        `;
        stepsWrapper.innerHTML += newStep;
      }
      prevStepName = currentStepName;
    });
  }

  handleStepProgress() {
    const currentActiveTab = this.querySelector('.step-container.active').dataset.stepName;
    const previouslyActiveStep = this.querySelector('.step.active');
    const childActiveSteps = this.querySelectorAll('.step-container[data-step-name="' + currentActiveTab + '"]');
    const activeStep = this.querySelector('.step[data-step-for="' + currentActiveTab + '"]');
    const completedChildSteps = Array.from(childActiveSteps).filter((step) => step.classList.contains('completed'));
    const progress_width = 33.33 + (completedChildSteps.length / childActiveSteps.length) * 100;
    if (childActiveSteps.length > 1) {
      if (activeStep.querySelector('.progress-step')) {
        activeStep.querySelector('.progress-step').style.width = progress_width + '%';
      } else {
        const progressBar = `
      <div class="progress-container">
        <div class="progress-step" style="width:${progress_width}%;">
        </div>
      </div>
      `;
        activeStep.innerHTML += progressBar;
      }
    }
    if (previouslyActiveStep) {
      previouslyActiveStep.classList.remove('active'); // remove the active class from previously active step
    }
    activeStep.classList.add('active');
  }

  showSwitchedTab(n) {
    const steps = this.buyingSteps;
    const step = steps[n];
    if (!step) {
      return;
    }
    step.classList.add('active');
    this.prevStepButton.classList.toggle('disabled', n === 0);

    if (steps.length - 2 === n) {
      this.nextStepButton.querySelector('span').textContent = 'View Quote';
    } else if (steps.length - 1 === n) {
      this.nextStepButton.classList.add('hidden');
      this.querySelector('#submit').style.display = 'flex';
    } else {
      this.nextStepButton.classList.remove('hidden');
      this.querySelector('#submit').style.display = 'none';
      this.nextStepButton.querySelector('span').textContent = 'Next';
    }

    this.handleStepProgress(); // update the progress bar according to completed steps.
  }

  switchStep(n) {
    const currentStep = this.buyingSteps[this.currentTab];
    if (!currentStep) {
      return;
    }
    currentStep.classList.remove('active');
    this.buyingSteps.forEach((step, index) => {
      if (index <= this.currentTab + n) {
        step.classList.remove('active');
      }
    });
    if (n > 0) {
      currentStep.classList.add('completed');
      n += parseInt(this.nextStepButton.dataset.increment);
    } else {
      currentStep.classList.remove('completed');
      n -= parseInt(this.prevStepButton.dataset.decrement);
    }

    this.currentTab += n;
    this.showSwitchedTab(this.currentTab);
    this.stepChangeCallback(currentStep);
  }

  stepChangeCallback(currentStep) {
    console.log('Step changed');
    console.log(currentStep);
  }

  setActiveNextButton() {
    this.nextStepButton.classList.remove('disabled');
  }

  setDisableNextButton() {
    this.nextStepButton.classList.add('disabled');
  }

  setActiveStepOnUrlParam() {
    // Get the full query string from the URL
    const queryString = window.location.search;

    // Create a URLSearchParams object from the query string
    const urlParams = new URLSearchParams(queryString);

    // Get the value of the "stepNo" parameter
    const stepNo = parseInt(urlParams.get('stepNo') - 1);
    if (stepNo > 0) {
      this.switchStep(stepNo);
    } else {
      this.showSwitchedTab(this.currentTab); // Displays the first tab on page load
    }
  }
}

customElements.define('buying-journey', BuyingJourney);
